import { ReactNode } from 'react';

import { styled } from '@mui/material';

import { ModalMode } from '@app-velocity/message-bus';

import { Box } from '../../../Box';
import { useModalWrapperContext } from '../../context/useModalWrapperContext';

export type HeaderWrapperProps = {
  children: ReactNode;
};

const StyledHeaderWrapper = styled(Box)<{ mode: ModalMode }>(
  ({ mode, theme }) => ({
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${mode === 'subview' ? 8 : '16px 20px'}`,
    borderBottom: '1px solid var(--color-general-grey-300)',
    boxSizing: 'border-box',
    height: mode === 'subview' ? 48 : undefined,
    width: '100%',
  })
);

export const HeaderWrapper = ({ children }: HeaderWrapperProps) => {
  const { mode } = useModalWrapperContext();

  return (
    <StyledHeaderWrapper component="header" mode={mode}>
      {children}
    </StyledHeaderWrapper>
  );
};
